'use client';
import { useRouter } from 'next/navigation';

import getAPI from '@graphql/getAPI';
import { Link } from '@heroui/link';
import { FormFieldHelpers, ZodForm } from '@rachelallyson/hero-hook-form';
import Icon from '@Soultrics/_components/Icon';
import { capture, EventType } from '@Soultrics/_utils/events';
import { z } from 'zod';

const loginSchema = z.object({
  email: z
    .string()
    .email('Must be a valid email address')
    .min(1, 'Email is required'),
  password: z.string().min(1, 'Password is required'),
});

type LoginFormData = z.infer<typeof loginSchema>;

function Login() {
  const router = useRouter();

  return (
    <>
      <div className="flex items-center">
        <div className="grid p-4 gap-4 items-center w-full">
          <div className="text-center text-primary">
            <Icon name="GLOBAL_LOGO_Icon" size="80" />
            <br />
            Login
          </div>
          <ZodForm<LoginFormData>
            config={{
              defaultValues: {
                email: '',
                password: '',
              },
              fields: [
                FormFieldHelpers.input('email', 'Email', 'email'),
                FormFieldHelpers.input('password', 'Password', 'password'),
              ],
              schema: loginSchema,
            }}
            submitButtonText="Log in"
            onSubmit={async (info: { email: string; password: string }) => {
              const client = getAPI();

              await client.login(info, { revalidate: ['me'] });
              capture(EventType.USER_LOGGED_IN);
            }}
            onSuccess={() => {
              router.push('/admin/dashboards');
            }}
          />
          <div className="grid grid-cols-2">
            <Link href="/forgot">Recover Password</Link>
          </div>
        </div>
      </div>
    </>
  );
}
export default Login;
